import React, {useState} from 'react';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';

import {ErrorDialog} from '../../../components/ui-controls/ErrorDialog';
import ContentView from '../../../components/ui-controls/layout/ContentView';
import {MAX_CONTENT_WIDTH} from '../../../giftCardShop/constants';
import {AppRoute} from '../../../models/AppRoute';
import {EnquireVoucherErrorResponse, EnquireVoucherResponse} from '../../../models/middleware';
import {RouteNavigatorScreenProps} from '../../../models/navigationTypes';
import apiService from '../../../transport/apiService';
import {logger} from '../../../utils/logger';

import GiftCardBalanceView from './GiftCardBalanceView';
import GiftCardDataInputFormView from './GiftCardDataInputView';

// Zen uses "200 OK" for errors
const isErrorResponse = (
  res: EnquireVoucherResponse | EnquireVoucherErrorResponse,
): res is EnquireVoucherErrorResponse => 'result' in res;

const GiftCardsCheckBalanceScreen = ({
  navigation,
}: RouteNavigatorScreenProps<AppRoute.GIFT_CARDS_CHECK_BALANCE>) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [giftCardData, setGiftCardData] = useState<EnquireVoucherResponse>();
  const [submitErrorMessage, setSubmitErrorMessage] = useState('');

  const handleSubmit = async (serialNumber: string, pin: string) => {
    setIsSubmitting(true);
    try {
      const response = await apiService.getGiftCardVoucherData(serialNumber, pin);

      const giftCardResponse = response.data;
      if (!giftCardResponse) throw new Error('No data returned');

      if (isErrorResponse(giftCardResponse)) {
        setGiftCardData(undefined);
        setSubmitErrorMessage('We are having trouble verifying your Gift Card, please try again.');
      } else if (giftCardResponse.voucher) {
        setGiftCardData(giftCardResponse);
      } else throw new Error('No data returned');
    } catch (error) {
      logger.error('GiftCardsCheckBalanceScreen', 'Error checking gift card balance', {error});
      setGiftCardData(undefined);
      setSubmitErrorMessage("Sorry, we couldn't get your data at this moment. Please try again.");
    }
    setIsSubmitting(false);
  };
  const handleViewBalanceOk = () => setGiftCardData(undefined);
  const handleErrorDialogOk = () => setSubmitErrorMessage('');
  const handleContactUsPress = () => navigation.navigate(AppRoute.CONTACT_US);

  return (
    <ContentView style={{maxWidth: MAX_CONTENT_WIDTH}}>
      <KeyboardAwareScrollView
        keyboardShouldPersistTaps="handled"
        enableOnAndroid
        extraScrollHeight={40}>
        {giftCardData ? (
          <GiftCardBalanceView
            giftCardData={giftCardData}
            onOk={handleViewBalanceOk}
            onContactUs={handleContactUsPress}
          />
        ) : (
          <GiftCardDataInputFormView onSubmit={handleSubmit} isSubmitting={isSubmitting} />
        )}
        <ErrorDialog
          isVisible={!!submitErrorMessage}
          onOk={handleErrorDialogOk}
          message={submitErrorMessage}
        />
      </KeyboardAwareScrollView>
    </ContentView>
  );
};

export default GiftCardsCheckBalanceScreen;
